import { ComponentType } from 'react'

import { ChatMode } from '../../core/types/chat.types'
import AnalyzeEmptyState from './analyze-empty-state'
import BudgetEmptyState from './budget-empty-state'
import ExploreEmptyState from './explore-empty-state'
import OpenChatEmptyState from './open-chat-empty-state'

// Registry maps ChatMode to the empty-state component shown when there are no messages.
// Each component receives optional callback props; unused props are silently ignored.
export type EmptyStateProps = {
  onModeSelect?: (mode: ChatMode) => void
  onStartCompare?: () => void
  onStartBudget?: () => void
  onSelectCard?: (card: unknown) => void
}

export const emptyChatComponents: Partial<Record<ChatMode, ComponentType<EmptyStateProps>>> = {
  DEFAULT: OpenChatEmptyState,
  COMPARE: AnalyzeEmptyState,
  EXPLORE: ExploreEmptyState,
  BUDGET: BudgetEmptyState,
}

/**
 * Fallback for modes without a dedicated empty state (VISUALIZE, TRANS_LANG_CURR, etc.)
 * These modes are internal and should not normally show an empty chat.
 */
export const defaultEmptyComponent: ComponentType<EmptyStateProps> = OpenChatEmptyState
